import { generateKeyBetween } from "fractional-indexing";

type FractionalOrderable =
    | { _id: string; order: string; id?: never; }
    | { id: string; order: string; _id?: never; };

function getItemIndex(
    itemId: string,
    items: FractionalOrderable[]
) {
    return items.findIndex(({ _id }) => _id === itemId) ?? items.findIndex(({ id }) => id === itemId);
}

export function getNewFractionalOrder(
    id: string | null,
    index: number,
    items: FractionalOrderable[]
) {
    const oldIndex = id ? getItemIndex(id, items) : -1;
    const previousIndex = oldIndex !== -1 && oldIndex < index ? index : index - 1;
    const previous = items[previousIndex];
    const next = items[previousIndex + 1];
    const order = generateKeyBetween(previous?.order, next?.order);

    return { order, oldIndex };
}

export function getIndexFromFractionalOrder(
    id: string,
    newOrder: string,
    items: FractionalOrderable[]
) {
    const oldIndex = getItemIndex(id, items);
    let index = 0;

    while (index < items.length && newOrder > items[index].order) {
        index++;
    }

    if (oldIndex !== -1 && oldIndex < index) {
        index--;
    }

    return { index, oldIndex };
}

export function sortByOrder(a: FractionalOrderable, b: FractionalOrderable) {
    if (a.order < b.order) {
        return -1;
    }

    if (a.order > b.order) {
        return 1;
    }

    return 0;
}
